<template>
  <div class="dialog-comp">
    <div class="dialog-mask">
    </div>
    <div class="dialog-box">
      <div class="dialog-hd">
        <div v-if="icon" :class="iconClass"></div>
        <div class="dialog-title">{{title}}</div>
      </div>
      <div class="dialog-bd">
        <div v-if="text_l1" class="dialog-content dialog-content_l1">{{text_l1}}<br/>{{text_l2}}</div>
      </div>
      <div class="dialog-ft dialog-btn-group">
        <button v-if="cancelTxt" class="dialog-btn dialog-btn_gray" @click="cancelFn">{{cancelTxt}}</button>
        <button v-if="sureTxt" class="dialog-btn dialog-btn_green" @click="sureFn">{{sureTxt}}</button>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        props: {
            icon: {
                type: String,
                default: ''
            },
            msg: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
            text_l1: {
                type: String,
                default: '',
            },
            text_l2: {
                type: String,
                default: '',
            },
            sureTxt: {
                type: String,
                default: ''
            },
            cancelTxt: String,
            sureFn: Function,
            cancelFn: Function
        },
        computed: {
            iconClass: function () {
                return 'dialog-icon dialog-icon_' + this.icon;
            }
        }
    };
</script>
<style scoped lang="less">
  @rem: 200rem;
  button {
    border: 0;
    outline: none;
  }

  .dialog {
    &-comp {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      position: fixed;
      z-index: 98
    }

    &-mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.5;
      z-index: 99;
    }

    &-box {
      width: 500/@rem;
      height: auto;
      margin: auto auto auto auto;
      border-radius: 18/@rem;
      z-index: 100;
      background: #fff url(../img/dialog-hd-bg-color.png) no-repeat no-repeat;
      background-size: 411/@rem 116/@rem;
      background-position: center 20/@rem;
    }

    &-title {
      font-size: 40/@rem;
      line-height: 80/@rem;
      height: 80/@rem;
      text-align: center;
    }

    &-content{
      padding: 20/@rem 20/@rem;
    }

    &-icon {
      width: 118/@rem;
      height: 118/@rem;
      margin: 46/@rem auto 20/@rem auto;

      &_ok {
        background: url(../img/dialog-icon-ok.png);
        background-size: cover;
      }

      &_error{
        display: none;
      }

      &_smile {
        background: url(../img/dialog-icon-act-end.png);
        background-size: cover;
      }

    }

    &-bd {
      font-size: 26/@rem;
      line-height: 40/@rem;
      text-align: center;
      margin-bottom: 40/@rem;
      color: #999999;
    }

    &-ft {
      margin: 0 20/@rem 25/@rem 20/@rem;
      height: 88/@rem;
      line-height: 88/@rem;
      font-size: 38/@rem;

    }

    &-btn {
      flex: 1;
      -webkit-flex: 1;
      border-radius: 10/@rem;

      &:nth-child(2) {
        margin-left: 15/@rem;
      }

      &-group {
        display: flex;
        display: -webkit-flex;
      }

      &_green {
        background: #37cf74;
        color: #fff;

        &:hover {
          background: #37cf74;
        }

        &:active {
          background: #94ceab;
        }
      }

      &_gray {
        background: #c4c0c0;
        color: #fff;

        &:hover {
          background: #c4c0c0;
        }

        &:active {
          background: #dfd9d9;
        }
      }
    }
  }

  .lang-zh-hk {
    .dialog-btn {
      font-size: 28/@rem;
    }
  }
  .lang-en {
    .dialog-btn {
      font-size: 36/@rem;
    }
  }
  .lang-id {
    .dialog-btn {
      font-size: 22/@rem;
    }
  }
</style>